import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Form,
  Field,
  FieldArray,
  reduxForm,
} from 'redux-form';
import {
  phone,
  email,
  normalizePhone,
  validateSiteContacts,
} from '../../../helpers';
import getLabel from '../../../helpers/getLabel';
import TextField from '../../TextField';
import RadioButtonGroup from '../../RadioButtonGroup';

const renderMembers = ({
  fields,
  enums,
}) => (
  <Fragment>
    {
      fields.map((member, index) => {
        const memberType = fields.get(index).type;

        return (
          <div className="contact-block" key={fields.get(index).type}>
            <h4>{getLabel(enums.siteMemberTypes.options, memberType)}</h4>
            <div className="w-form">
              <div className="field-combo-wrapper-2 w-clearfix">
                <div className="field-combo-2">
                  <Field
                    label={<label htmlFor="First-3" className="field-label">First Name</label>}
                    component={TextField}
                    name={`${member}.firstName`}
                    className="text-field w-input"
                  />
                </div>
                <div className="field-combo-2">
                  <Field
                    label={<label htmlFor="First-3" className="field-label">Last Name</label>}
                    component={TextField}
                    name={`${member}.lastName`}
                    className="text-field w-input"
                  />
                </div>
              </div>
              <div className="field-combo-wrapper-2 w-clearfix">
                <div className="field-combo-2">
                  <Field
                    label={<label htmlFor="First-3" className="field-label">Phone</label>}
                    component={TextField}
                    validate={phone}
                    normalize={normalizePhone}
                    name={`${member}.phone`}
                    className="text-field w-input"
                  />
                </div>
                <div className="field-combo-2">
                  <Field
                    label={<label htmlFor="First-3" className="field-label">Email</label>}
                    component={TextField}
                    validate={email}
                    name={`${member}.email`}
                    className="text-field w-input"
                  />
                </div>
              </div>
              <div className="field-combo-wrapper-2 w-clearfix">
                <div className="field-combo-2">
                  <Field
                    label={<label htmlFor="First-3" className="field-label">Job Title</label>}
                    component={TextField}
                    name={`${member}.title`}
                    className="text-field w-input"
                  />
                </div>
              </div>
              <div className="radio-question">
                <label htmlFor="First-3" className="field-label">Is this the site Supervisor?</label>
                <Field
                  name={`${member}.isSupervisor`}
                  component={RadioButtonGroup}
                  className="radio-field inline-radio w-radio"
                  parse={val => val === 'true'}
                />
              </div>
            </div>
          </div>
        );
      })
    }
  </Fragment>
);

renderMembers.propTypes = {
  enums: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
};

const ContactForm = reduxForm({
  form: 'siteContacts',
  validate: validateSiteContacts,
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(({
  handleSubmit,
  submitting,
  update,
  enums,
}) => (
  <Form onSubmit={handleSubmit(update)}>
    <FieldArray
      name="siteMembers"
      component={renderMembers}
      props={{ enums }}
    />
    <div>
      <input
        type="submit"
        value={submitting ? 'Please wait...' : 'Save Changes'}
        disabled={submitting}
        className="btn-solid-green w-button"
      />
    </div>
    <br />
    <br />
  </Form>
));

const mapStateToProps = (reduxState, props) => {
  const { site } = props;
  const { siteId } = site;
  const siteMemberTypes = ['PRIMARY_POINT_CONTACT', 'SECONDARY_POINT_CONTACT'];
  const siteMembers = [];

  siteMemberTypes.forEach((memberType) => {
    const existingMember = site.siteMembers.find(({ type }) => type === memberType);

    if (existingMember) {
      const {
        siteMemberId,
        email: existingMemberEmail,
        firstName,
        lastName,
        phone: existingMemberPhone,
        title,
        type,
        isSupervisor,
      } = existingMember;

      siteMembers.push({
        siteMemberId,
        email: existingMemberEmail,
        firstName,
        lastName,
        phone: existingMemberPhone,
        title,
        type,
        isSupervisor,
      });
    } else {
      siteMembers.push({ type: memberType });
    }
  });

  return {
    initialValues: {
      siteId,
      siteMembers,
    },
  };
};

ContactForm.propTypes = {
  enums: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(ContactForm);
